import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Mixpanel from "mixpanel-browser";
import { useDispatch, useSelector } from "react-redux";
import Button from "../form-components/Button";
import Fields from "../form-components/Fields";
import PhoneInput from "react-phone-input-2";
import settingPageValidation from "../../validations/settingValidation/settingValidation";
import { getProfileData } from "../../features/profile-management/getProfileDataSlice";
import { manageProfile } from "../../features/profile-management/manageProfileSlice";
import { OK } from "../../constants/statusCode";
// import { showSuccess } from "../../utils/messageHelper";
import UpdatePasswordModal from "./modal/UpdatePasswordModal";
import { RoleRightsForModule } from "../../utils/utils";

const Profile = ({ currentModal, setCurrentModal, toggleFunction }) => {
  const [code, setCode] = useState("");
  const [codeMobile, setCodeMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [mobile, setMobile] = useState("");
  const dispatch = useDispatch();

  let userData = JSON.parse(localStorage.getItem("_user"));
  const { profileData = {} } = useSelector(
    (state) => state?.getProfileDataReducer
  );

  const mobileNumberHandler = (value, code) => {
    setCode(code?.dialCode);
    setCodeMobile(value);
    let number = value.substring(code?.dialCode?.length);
    setMobile(number);
    if (number && !(number.length > 7 && number.length < 12)) {
      setMobileError("Mobile number must be 8 to 11 digits.");
    } else {
      setMobileError("");
    }
  };

  useEffect(() => {
    dispatch(getProfileData(userData?.organizations[0].uuid));
  }, []);

  const validate = (values) => {
    const errors = {};
    if (mobile) {
      values.mobile = mobile;
    }
    if (
      values.mobile &&
      !(values.mobile.length > 7 && values.mobile.length < 12)
    ) {
      errors.mobile = "Mobile number must be 8 to 11 digits.";
      setMobileError(errors.mobile);
    }
  };
  let profilePermission = RoleRightsForModule("Update", "Profile");

  return (
    <>
      {Object.keys(profileData).length > 0 && (
        <Formik
          initialValues={{
            first_name: profileData?.first_name || "",
            last_name: profileData?.last_name || "",
            email: profileData?.email || "",
            password: "",
            codeMobile: profileData?.isd_code + profileData?.mobile,
            isd_code: profileData?.isd_code,
            organization_name: profileData?.Organizations[0]?.name ? profileData?.Organizations[0]?.name : ''
          }}
          validate={validate}
          validationSchema={settingPageValidation}
          onSubmit={async (values) => {
            if (
              values.mobile &&
              !(values.mobile.length > 7 && values.mobile.length < 12)
            ) {
              setMobileError("Mobile number must be 8 to 11 digits.");
            } else {
              values.mobile = mobile;
              values.isd_code = code;
              Mixpanel.track("Update Profile Button Clicked", {
                Page: "Update Profile Modal",
              });
              const { payload } = await dispatch(manageProfile(values));
              if (payload.status === OK) {
                // showSuccess(payload?.data?.responseMessage);
                const data = await dispatch(getProfileData(userData?.organizations[0].uuid));
                userData.first_name =
                  data?.payload?.data?.responseData?.user?.first_name;
                userData.last_name =
                  data?.payload?.data?.responseData?.user?.last_name;
                localStorage.setItem("_user", JSON.stringify(userData));
                // console.log(payload?.data?.responseData?.user)
                // localStorage.setItem('_user', JSON.stringify(payload?.data?.responseData?.user));
              }
            }
          }}
        >
          {({
            values,
            handleChange,
            handleBlur,
            touched,
            errors,
            isSubmitting,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form className="profile-form">
              <div className="row">
                <div className="col-xl-12 col-xxl-12 col-lg-12">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">First Name</label>
                        <Fields
                          type="text"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="first_name"
                          value={values.first_name}
                          placeholder="First Name"
                          className="form-control"
                          onChange={handleChange}
                          disabled={profilePermission === true ? false : true}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Last Name</label>
                        <Fields
                          type="text"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="last_name"
                          value={values.last_name}
                          placeholder="Last Name"
                          className="form-control"
                          onChange={handleChange}
                          disabled={profilePermission === true ? false : true}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="form-label">Email</label>
                        <Fields
                          type="email"
                          placeholder="Email"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="email"
                          value={values.email}
                          className="form-control"
                          onChange={handleChange}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="form-label">Organisation name</label>
                        <Fields
                          type="text"
                          placeholder="organisation_name"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="organization_name"
                          value={values.organization_name}
                          className="form-control"
                          onChange={handleChange}
                        /* disabled={true} */
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      {/* <div className="form-group">
                                            <label className="form-label">Password</label>
                                            <div className='input-group addon-right'>
                                                <Input
                                                    type={togglePassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    touched={touched}
                                                    errors={errors}
                                                    onBlur={handleBlur}
                                                    name="password"
                                                    value={values.password}
                                                    className="form-control"
                                                    onChange={handleChange}
                                                />
                                                <span className='input-group-text'><a href='#' className='addon-link'>Change Password</a></span>
                                            </div>
                                            <div className="mt-0 mx-0">
                                                <ErrorMessage
                                                    name="password"
                                                    component={({ children }) => (
                                                        <div className="text-start text-danger mb-2 mt-2">{children}</div>
                                                    )}
                                                />
                                            </div>
                                        </div> */}
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="form-label">Phone</label>
                        <PhoneInput
                          // onKeyDown={(e) => console.log(e.keyCode)}
                          country={values.isd_code ? values.isd_code : "us"}
                          name="mobile"
                          id="mobile"
                          searchPlaceholder="Search country"
                          disableInitialCountryGuess={false}
                          enableLongNumbers={true}
                          countryCodeEditable={false}
                          onChange={mobileNumberHandler}
                          value={values.codeMobile}
                          enableSearch={true}
                          disabled={profilePermission === true ? false : true}
                        />
                        <div className="mt-0 mx-0">
                          <div className="text-start text-danger mb-2 mt-2">
                            {mobileError}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 text-start mb-3 mb-md-0">
                      <Button
                        type="button"
                        className="btn create-doc-btn create-doc-btn-margin mt-0"
                        onClick={() => setCurrentModal("UpdatePasswordModal")}
                      >
                        Change Password
                      </Button>
                    </div>
                    <div className="col-12 col-md-6   text-start text-md-end">
                      <Button
                        type="button"
                        className="btn btn-primary-md"
                        onClick={handleSubmit}
                        disabled={profilePermission === false ? true : isSubmitting}
                      >
                        Save Changes
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}

      {currentModal === "UpdatePasswordModal" && (
        <UpdatePasswordModal
          isVisible={currentModal === "UpdatePasswordModal"}
          toggleFunction={toggleFunction}
        />
      )}
    </>
  );
};

export default Profile;
